import React, { useCallback } from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarSize } from '@atlaskit/editor-common/types';
import { changeAlignment } from '../editor-commands';
import { ToolbarType } from '../pm-plugins/types';
import ToolbarAlignment from './ToolbarAlignment';
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    disabled = _ref.disabled,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement,
    isToolbarReducedSpacing = _ref.isToolbarReducedSpacing,
    _ref$toolbarSize = _ref.toolbarSize,
    toolbarSize = _ref$toolbarSize === void 0 ? ToolbarSize.XXL : _ref$toolbarSize;
  var _useSharedPluginState = useSharedPluginState(api, ['alignment']),
    alignmentState = _useSharedPluginState.alignmentState;
  var changeAlignmentCallback = useCallback(function (align) {
    return changeAlignment(align, api, INPUT_METHOD.TOOLBAR)(editorView.state, editorView.dispatch);
  }, [editorView, api]);
  return /*#__PURE__*/React.createElement(ToolbarAlignment, {
    pluginState: alignmentState,
    isReducedSpacing: isToolbarReducedSpacing,
    changeAlignment: changeAlignmentCallback
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    disabled: disabled || !alignmentState.isEnabled,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    api: api,
    toolbarType: ToolbarType.PRIMARY,
    toolbarSize: toolbarSize
  });
}